<template>
    <div class="CloudClassroomCollection_wrap">
        <el-page-header @back="$core.goBack" ></el-page-header>
        <!-- 头部图片 -->
        <div class="top_img">
            <div class="title_one">{{columnName}}原创文章合集</div>
            <div class="title_two">collection of original articles</div>
        </div>
        <!-- 搜索框 -->
        <div class='project_serch'>
            <el-input v-model='filter.searchKey' placeholder='文章标题关键字/词' class='project_input'>
                <el-button @click='getArticleList' slot='suffix' round type='primary'>搜索</el-button>
            </el-input>
        </div>
        <!-- 排序 -->
        <div class="passage_big_content">
            <div class="selection_wrap flex-between">
                <div></div>
                <el-form  label-width="80px" class="selection">
                    <el-form-item label="排序:">
                        <el-select placeholder="请选择" @change="getArticleList" v-model="filter.sortType">
                            <el-option v-for="item in selectList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-for="item in articleList" :key="item.id" class="single_passage" @click="toArticleDetail(item.id)">
                <div class="title_img">
                    <img :src="item.imageUrl" alt="" />
                </div>
                <div class="title_msg">{{item.title}}</div>
                <div class="flex-between other_wrap">
                    <div>发布时间:{{item.createTime}}</div>
                    <div>阅读量:{{item.browseNum}}</div>
                </div>
            </div>
            <div class="page_wrap">
                <el-pagination  layout="prev, pager, next" :page-size="5"  @current-change="getArticleList" :current-page.sync="pages.currentPage" :total="pages.total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { articleCollection } from '../../utils/api';

export default {
    data() {
        return {
            columnName:this.$route.query.columnName,
            filter:{
                searchKey:'',
                userId:this.$route.query.authorId,
                subjectId:this.$route.query.subjectId,
                sortType:0
            },
            pages:{
                currentPage:1,
                total:0
            },
            articleList:[],
            selectList:[{
                id:0,
                label:'最晚发布'
            },{
                id:1,
                label:'最早发布'
            },{
                id:2,
                label:'浏览量'
            },],

        };
    },
    mounted(){
        this.getArticleList()
    },
    methods: {
        getArticleList(){
            let params = {
                keyword:this.filter.searchKey,
                page:this.pages.currentPage,
                size:5,
                userId:this.filter.userId,
                sort:this.filter.sortType,
                subjectId:this.filter.subjectId
            }
            articleCollection(params).then(res => {
                this.articleList = res.data.list;
            }).catch(err=>{})
        },

        //查看文章详情
        toArticleDetail(id){
            this.$router.push({path:'/articleDetail',query:{articleId:id}})
        },

    }
};

</script>

<style lang="scss" scoped>

.CloudClassroomCollection_wrap {
    padding-top: 65px;
    height: 2000px;
    text-align: center;
    color: #5277f7;
    .top_img {
        width: 100%;
        height: 450px;
        background: url('../../assets/img/coding.png') 0 0/100% 100% no-repeat;
        .title_one {
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 42px;
            padding-top: 180px;
        }
        .title_two {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 25px;
            margin-top: 25px;
        }
    }
    .project_serch {
        width: 300px;
        height: 50px;
        margin: 20px auto;
        .el-button{
            position: relative;
            left: 5px;
          }
        /deep/ .el-input__inner {
            border-radius: 150px !important ;
        }
        .serch_btn {
            width: 60px;
            height: 40px;
            background: #5277f7;
            border-radius: 20px;
            text-align: center;
            position: relative;
            left: 215px;
            top: -40px;
            span {
                line-height: 40px;
                color: #fcfcff;
                // font-size: 20px;
            }
        }
        .tips_info {
            color: #3c3c3c;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 22px;
            position: relative;
            top: -15px;
        }
    }
    .selection_wrap{
        width: 100%;
        text-align: right;
        margin-top: 100px;
        height: 40px;
        line-height: 40px;
        /deep/.el-form-item__label{
            color: #5277f7;
        }
        .selection {
            width: 270px;
        }
    }

    .passage_big_content {
        width: 100%;
        box-sizing: border-box;
        padding: 0px 250px;
        .single_passage {
            padding: 20px 40px 20px 25px;
            width: 100%;
            height: 230px;
            background: #fcfcff;
            box-shadow: 0px 3px 12px rgba(189, 204, 255, 0.3);
            color: #3C3C3C;
            box-sizing: border-box;
            align-items: center;
            display: flex;
            margin-top: 30px;
            .title_img {
                width: 22%;
                text-align: center;
                img {
                    height: 190px;
                    width: 100%;
                }
            }
            .title_msg {
                width: 53%;
                box-sizing: border-box;
                padding-left: 50px;
                text-align: left;
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #5277f7;
            }
            .other_wrap{
                align-self: flex-end;
                margin-bottom: 20px;
                width: 25%;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #3c3c3c;
            }
        }
        .single_passage:hover{
            opacity: 0.9;
            background: #f3f3f5;
            cursor: pointer;
        }
    }
    .page_wrap {
        height: 60px;
        line-height: 60px;
        text-align: center;
        margin-top: 100px;
    }
}
/deep/.el-pagination .btn-prev {
    background: none;
}
/deep/.el-pagination .btn-next {
    background: none;
}
/deep/ .number {
    font-size: 22px;
    font-weight: 50;
    color: #909399;
    background: none;
}
</style>
